import * as React from "react";
import { css, cx } from "emotion";
import { ToolbarButtons } from "./toolbarbuttons";
import Grid from "../grid/grid";
import GridItem from "../grid/griditem";
import { Button } from "./button";
import { getThemeColorVar } from "../helper/color";
import FlexContainer from "../grid/flexcontainer";
const lightHeaderClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    minHeight: "172px",
    paddingLeft: "24px",
    paddingRight: "24px",
    borderBottom: `1px solid ${getThemeColorVar("border", "default")}`,
});
const toolbarClass = css({
    marginTop: "24px",
    marginBottom: "24px",
    fontSize: "12px",
});
const titleClass = css({
    color: getThemeColorVar("typo", "dark"),
    fontSize: "24px",
    lineHeight: "24px",
    fontWeight: 900,
    minHeight: "24px",
});
const contentClass = css({
    marginTop: "24px",
    marginBottom: "24px",
});
const actionsClass = css({
    marginBottom: "24px",
});
export const LightHeader = (props) => {
    const { title, backLabel, backAction, toolbarButtons, actions, children } = props;
    return (React.createElement("div", { className: cx(lightHeaderClass) },
        React.createElement(FlexContainer, null,
            props.title === "" && React.createElement("div", null),
            props.title !== "" && React.createElement(Grid, null),
            React.createElement("div", null)),
        React.createElement(Grid, { columns: 1 },
            backAction && (React.createElement("div", { className: cx(toolbarClass) },
                React.createElement(Grid, { columns: backAction.toString() ? 2 : 1 },
                    backAction && (React.createElement(GridItem, { justifySelf: "start" },
                        React.createElement(Button, { onClick: backAction, icon: "back", type: "tertiary", size: "tiny" }, backLabel))),
                    toolbarButtons && React.createElement(ToolbarButtons, { buttons: toolbarButtons })))),
            React.createElement(Grid, { columnSpec: actions
                    ? [
                        [2, "fr"],
                        [1, "fr"],
                    ]
                    : [[1, "fr"]] },
                React.createElement("div", { className: cx(titleClass) }, title),
                actions && (React.createElement(GridItem, { rowSpan: 2, alignSelf: "end", justifySelf: "end" },
                    React.createElement("div", { className: cx(actionsClass) }, actions))),
                React.createElement("div", { className: cx(contentClass) }, children)))));
};
export default LightHeader;
//# sourceMappingURL=lightheader.js.map